import { heroStats, keywordRibbon } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-28 md:pt-32">
      <div className="pointer-events-none absolute -left-24 top-24 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-accent-100/60 blur-3xl"></div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 pb-16 md:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16 lg:pb-24">
        <div className="flex flex-col items-start">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-newspaper-line text-sm" aria-hidden="true"></i>
            本期导读 · 访问指引特辑
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            金桔影院官网
            <br />
            最新地址与网址入口指南
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            找不到金桔影院官网？这里汇总了最新的地址、网址与常用入口信息，遇到
            <strong className="font-semibold text-foreground-950"> 打不开怎么办 </strong>
            也有清晰的应对思路。跟着下面的核对顺序走一遍，就能避开失效链接，直奔观影页面。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#address"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-map-pin-line text-base" aria-hidden="true"></i>
              查看最新地址
            </a>
            <a
              href="#trouble"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300/70 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-700"
            >
              <i className="ri-tools-line text-base" aria-hidden="true"></i>
              打不开怎么办
            </a>
          </div>

          <dl className="mt-10 grid w-full grid-cols-1 gap-4 sm:grid-cols-3">
            {heroStats.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-200/80 bg-background-100/70 px-4 py-4">
                <dt className="font-heading text-2xl font-bold text-primary-600">{stat.value}</dt>
                <dd className="mt-1 text-sm font-medium text-foreground-900">{stat.label}</dd>
                <dd className="mt-0.5 text-xs text-foreground-500">{stat.desc}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative rounded-2xl border border-background-300/70 bg-background-100 p-3 shadow-none">
            <div className="relative overflow-hidden rounded-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20composition%20with%20warm%20kumquat%20orange%20and%20cream%20tones%2C%20flowing%20film%20strip%20ribbons%2C%20soft%20geometric%20shapes%2C%20subtle%20paper%20grain%20texture%20background%2C%20cinematic%20dramatic%20lighting%2C%20artistic%20minimal%20poster%20illustration%2C%20elegant%20negative%20space%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=jv-hero-cover-main&orientation=portrait"
                alt="金桔影院 本期封面"
                title="金桔影院官网 最新地址 入口指南 封面"
                className="h-[420px] w-full object-top md:h-[520px]"
              />
              <div className="absolute left-4 top-4 flex flex-col gap-1 rounded-lg bg-foreground-950/70 px-3 py-2 text-background-50">
                <span className="text-[10px] tracking-[0.3em]">ISSUE</span>
                <span className="font-heading text-lg font-bold leading-none">2026 / 10</span>
              </div>
            </div>
            <div className="mt-3 flex items-center justify-between px-1 pb-1">
              <span className="font-heading text-sm font-bold text-foreground-950">本期封面 · 访问指引特辑</span>
              <span className="text-xs text-primary-700">主编推荐</span>
            </div>
          </div>

          <div className="absolute -bottom-5 -left-4 hidden rounded-lg border border-background-300/70 bg-background-50 px-4 py-3 sm:block">
            <p className="text-xs text-foreground-500">入口状态</p>
            <p className="mt-0.5 flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
              <span className="h-2 w-2 rounded-full bg-accent-500"></span>
              四条线路 · 三条通畅
            </p>
          </div>
        </div>
      </div>

      <div className="relative border-y border-background-200/80 bg-background-100/80 py-4">
        <div className="flex w-max animate-marquee gap-8 pl-8">
          {[...keywordRibbon, ...keywordRibbon].map((word, index) => (
            <span
              key={`${word}-${index}`}
              className="flex items-center gap-8 whitespace-nowrap text-sm text-foreground-600"
            >
              {word}
              <i className="ri-star-smile-line text-primary-400" aria-hidden="true"></i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}